/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".border-top[_ngcontent-%COMP%]{border-top:1px solid #bbb;padding:5px}.row-header[_ngcontent-%COMP%]{font-weight:600}.header-column[_ngcontent-%COMP%]{text-align:right}.border-top.target-cell[_ngcontent-%COMP%]{border-top:1px solid #000!important;border-left:1px solid #000!important;border-right:1px solid #000!important;border-bottom:0}.border-top.target-cell-last[_ngcontent-%COMP%]{border:1px solid #000!important}.revenue-input[_ngcontent-%COMP%]{text-align:center}\n/*# sourceMappingURL=revenue-print.component.css.map*/"];
export { styles as styles };
